import {
  Box,
  Chip,
  IconButton,
  Menu,
  MenuItem,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
  Typography
} from '@material-ui/core'
import React from 'react'

import LinkIcon from '@material-ui/icons/Link'
import LinkOffIcon from '@material-ui/icons/LinkOff'
import MoreVertIcon from '@material-ui/icons/MoreVert'
import PopupState, { bindMenu, bindTrigger } from 'material-ui-popup-state'
import { IUsuario, IUsuarioPerfil } from 'src/types'
import formatarDocumento from 'src/core/formatacoes/formatarDocumento'
import formatarTelefone from 'src/core/formatacoes/formatarTelefone'

interface Props {
  data: IUsuario[]
  handleExcluir: (id: string) => void
  handleResetarSenha: (item: IUsuario) => void
  handleEditar: (item: IUsuario) => void
  handleVisualizarDetalhes: (item: IUsuario) => void
}

export default function TabelaUsuarios({
  data,
  handleExcluir,
  handleEditar,
  handleResetarSenha
}: Props) {
  const handlePerfisName = (tenant: IUsuarioPerfil) => {
    if (tenant?.perfis) {
      return tenant.perfis?.map(perfil => perfil.nome).join(', ')
    }
  }
  const handlePerfisId = (tenant: IUsuarioPerfil) => {
    if (tenant?.perfis) {
      return tenant.perfis?.map(perfil => perfil.id).join(', ')
    }
  }

  const getBitrixStatus = (idBitrix?: number) =>
    idBitrix
      ? {
          tooltip: `Vinculado ao Bitrix (ID ${idBitrix})`,
          color: '#1E7E34'
        }
      : {
          tooltip: 'Sem vínculo com Bitrix',
          color: '#C62828'
        }

  return (
    <TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell style={{ width: 72, textAlign: 'center' }}>Bitrix</TableCell>
            <TableCell style={{ minWidth: 260 }}>Nome / CPF</TableCell>
            <TableCell>Contatos</TableCell>
            <TableCell>Tenants</TableCell>
            <TableCell style={{ textAlign: 'right' }}>Ações</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data?.map(item => {
            const bitrixStatus = getBitrixStatus(item?.idBitrix)

            return (
              <TableRow key={item.id}>
                <TableCell style={{ width: 72, textAlign: 'center' }}>
                  <Tooltip title={bitrixStatus.tooltip} placement="top">
                    {item?.idBitrix ? (
                      <LinkIcon style={{ color: bitrixStatus.color, fontSize: 22 }} />
                    ) : (
                      <LinkOffIcon style={{ color: bitrixStatus.color, fontSize: 22 }} />
                    )}
                  </Tooltip>
                </TableCell>
                <TableCell style={{ minWidth: 260 }}>
                  <Box display="flex" flexDirection="column" alignItems="flex-start">
                    <Typography variant="body2">{item?.nome}</Typography>
                    <Typography variant="caption" color="textSecondary">
                      {formatarDocumento(item?.cpf)}
                    </Typography>
                  </Box>
                </TableCell>
                <TableCell style={{ minWidth: '180px' }}>
                  <Typography variant="body2">
                    {formatarTelefone(item?.telefone)}
                  </Typography>
                  <Typography variant="caption" color="textSecondary">
                    {item?.email}
                  </Typography>
                </TableCell>
                <TableCell >
                  {item.perfisTenant.map(tenant => (
                    <>
                      <Tooltip title={handlePerfisName(tenant)} placement="top" key={handlePerfisId(tenant)}>
                        <Chip
                          style={{ margin: 2 }}
                          key={tenant.tenantId.toString()}
                          label={tenant?.descricao}
                        />
                      </Tooltip>
                    </>
                  ))}
                </TableCell>

                <TableCell style={{ textAlign: 'right' }}>
                  <PopupState variant="popover" popupId="demo-popup-menu">
                    {popupState => (
                      <React.Fragment>
                        <IconButton
                          aria-controls="simple-menu"
                          aria-haspopup="true"
                          aria-label="mais"
                          {...bindTrigger(popupState)}
                        >
                          <MoreVertIcon />
                        </IconButton>

                        <Menu
                          anchorOrigin={{
                            vertical: 'top',
                            horizontal: 'right'
                          }}
                          transformOrigin={{
                            vertical: 'top',
                            horizontal: 'right'
                          }}
                          {...bindMenu(popupState)}
                        >
                          <MenuItem
                            onClick={() => {
                              popupState.close()
                              handleEditar(item)
                            }}
                          >
                            Editar
                          </MenuItem>
                          <MenuItem
                            onClick={() => {
                              popupState.close()
                              handleResetarSenha(item)
                            }}
                          >
                            Resetar senha
                          </MenuItem>
                          <MenuItem
                            onClick={() => {
                              popupState.close()
                              handleExcluir(item?.id)
                            }}
                            className="danger"
                          >
                            Excluir
                          </MenuItem>
                        </Menu>
                      </React.Fragment>
                    )}
                  </PopupState>
                </TableCell>
              </TableRow>
            )
          })}
        </TableBody>
      </Table>
    </TableContainer >
  )
}
